import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./BlogsCards.css";

import img1 from "../../assets/images/blog1.png";
import img2 from "../../assets/images/blog2.png";
import img3 from "../../assets/images/blog3.png";
import img4 from "../../assets/images/blog4.png";
import img5 from "../../assets/images/blog5.png";
import img6 from "../../assets/images/blog6.png";

// Use `id` for dynamic routing instead of hardcoded paths
const cardData = [
  { id: 1, title: "From Numbers to Knowledge: The Art of Data Science", img: img1, date: "16 December 2024", comments: "No Comments" },
  { id: 2, title: "Empower Your Business with NMD Infotech’s Data Analytics Services", img: img2, date: "16 December 2024", comments: "No Comments" },
  { id: 3, title: "Unlocking Business Potential: How NMD Infotech Services Can Propel Your Growth", img: img3, date: "12 December 2024", comments: "No Comments" },
  { id: 4, title: "Digital Marketing vs Traditional Marketing", img: img4, date: "31 March 2024", comments: "No Comments" },
  { id: 5, title: "Tips for digital marketing", img: img5, date: "27 March 2024", comments: "No Comments" },
  { id: 6, title: "Tip’s Of Digital Marketing For Small Businesses", img: img6, date: "14 March 2024", comments: "No Comments" },
];

const BlogsCards = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const cards = document.querySelectorAll(".blog-glass-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <section className="blogs-cards-section">
      <h2 className="blogs-card-title">Latest Insights & IT Innovations</h2>

      <div className="blogs-grid">
        {cardData.map((card) => (
          <div className="blog-glass-card" key={card.id}>
            <img src={card.img} alt={card.title} />
            <h3>{card.title}</h3>

            <button className="read-btn" onClick={() => navigate(`/blogs/${card.id}`)}>
              Read More
            </button>

            <p className="blog-meta">
              {card.date} • {card.comments}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default BlogsCards;
